import baseConfig from './config';

// Production environment configuration
const productionConfig = {
  ...baseConfig,
  // Base URL for API calls in production
  baseUrl: 'https://test.lakshyajalandhar.com',
  
  // Production-specific settings
  debug: false,
  environment: 'production'
};

export default productionConfig; 